module.exports = {
	"id": "an",
	"name": "Antarctica",
	"month": "2016-09",
	"access_date": "2016-10-03",
	"data": {
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.028092,
			"27": 0.063207,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.309012,
			"39": 0.063207,
			"40": 0.337104,
			"41": null,
			"42": null,
			"43": 0.063207,
			"44": null,
			"45": 0.519702,
			"46": 0.028092,
			"47": 0.920013,
			"48": 11.271915,
			"49": 0.611001,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.273897,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.063207,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": null,
			"48": 0.028092,
			"49": 0.063207,
			"50": 0.091299,
			"51": 0.245805,
			"52": 14.39715,
			"53": 14.944944,
			"54": 0.028092,
			"55": null,
			"56": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.182598,
			"38": null,
			"39": 0.217713,
			"40": null,
			"41": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.091299,
			"8": 0.309012,
			"9": 2.724924,
			"10": 1.376508,
			"3.1": null,
			"3.2": null,
			"5.1": 1.348416,
			"6.1": null,
			"7.1": 0.428403,
			"9.1": 9.768993
		},
		"ios_saf": {
			"8": 0,
			"10": 2.63002413468,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.144612764004,
			"8.1-8.4": 0.302722719314,
			"9.0-9.2": 0.362495995103,
			"9.3": 6.0091423869
		},
		"android": {
			"3": 0,
			"4": 0.00117355732861,
			"52": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.000161869976359,
			"4.1": 0.00420861938534,
			"4.2-4.3": 0.0104810809693,
			"4.4": 0.0248065738771,
			"4.4.3-4.4.4": 0.0276392984634
		},
		"ie": {
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.519702,
			"11": 5.295342,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00449042372093,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000106914850498
		},
		"edge": {
			"12": 0.063207,
			"13": 2.085831,
			"14": 0.793599
		},
		"ie_mob": {
			"10": 0,
			"11": 0
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 1.699867
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0.0638736614286
		},
		"and_chr": {
			"0": 18.059483
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 98.901082
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-an.json
 ** module id = 690
 ** module chunks = 0
 **/